import { Component, inject } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { AuthConfig, OAuthModule, OAuthService } from 'angular-oauth2-oidc';
import { AppSettings } from '../appsetting.service';
import { environment } from '../../environments/environment.development';
import { DomSanitizer } from '@angular/platform-browser';
import { LoginService } from '../login.service';
import { LanguageComponent } from "../language/language.component";
import { LanguageService } from '../language.service';
declare let google: any;

@Component({
  selector: 'app-navbar',
  imports: [RouterLink, OAuthModule, LanguageComponent],
  standalone: true,
  templateUrl: './navbar.component.html',
  styleUrl: './navbar.component.css'
})
export class NavbarComponent {
  userProfile!: any;
  constructor(private oauthService: OAuthService, private router: Router, public sanitizer: DomSanitizer, public languageService:LanguageService) {
    if (this.oauthService.hasValidAccessToken()) {
      this.userProfile = this.oauthService.getIdentityClaims();
      router.navigateByUrl('/welcome')
    } else {
      this.configure();
    }
  }

  async configure() {
    let authConfig: AuthConfig = {
      ...environment.googleConfig,
      ...AppSettings.GOOGLE_AUTH_CONFIG
    };
    this.oauthService.configure(authConfig);
    this.oauthService.setupAutomaticSilentRefresh();
    this.oauthService.loadDiscoveryDocumentAndTryLogin().then(() => {
      if (!this.oauthService.hasValidAccessToken()) {
        this.oauthService.initCodeFlow();
      } else {
        this.userProfile = this.oauthService.getIdentityClaims();
        this.router.navigateByUrl('/welcome');

      }
    });
  }

  get isLoggedIn(): boolean {
    return !!this.oauthService.hasValidAccessToken();
  }

  get identityClaims(): any {
    return !!this.oauthService.getIdentityClaims();
  }

  onLogout() {
    this.oauthService.logOut();
    localStorage.clear();
    sessionStorage.clear();
    this.router.navigateByUrl('/logout');
  }
}
